import { useState, useEffect } from "react";
import "../../assets/css/GameList.css";
import MyGame from "../myGame/myGame";
import CreatedGames from "../createdgames/CreatedGames";
import Layout from "../../layouts/Layout";
import { useDispatch, useSelector } from "react-redux";
import Nav from 'react-bootstrap/Nav';

const Games = () => {
    const [IsGameList, setIsGameList] = useState(false);
    const [IsMyGame, setIsMyGame] = useState(false);
    const [IsCreatedGame, setIsCreatedGame] = useState(false);
    const [isFixed, setIsFixed] = useState(false);
    const [currentLocation, setCurrentLocation] = useState();
    const [profileLocation, setProfileLocation] = useState();

    const { accessToken, profileData } = useSelector((state) => state.loginInfo);
    const [activeTab, setActiveTab] = useState('joined-games');

    const onGameList = () => {
        setIsGameList(true);
        setIsMyGame(false);
        setIsCreatedGame(false);
        localStorage.setItem("selectedGameTab", "explore");
    };

    const onMyGame = () => {
        setIsMyGame(true);
        setIsGameList(false);
        setIsCreatedGame(false);
        localStorage.setItem("selectedGameTab", "joined");
    };

    const onCreatedGame = () => {
        setIsCreatedGame(true);
        setIsMyGame(false);
        setIsGameList(false);
        localStorage.setItem("selectedGameTab", "hosted");
    };

    useEffect(() => {
        const savedTab = localStorage.getItem("selectedGameTab");
        if (savedTab === "joined") onMyGame();
        else if (savedTab === "hosted") onCreatedGame();
        else onGameList();
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY >= 60) {
                setIsFixed(true);
            } else {
                setIsFixed(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const getLocationName = async (lat, lng) => {
        const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

        try {
            const response = await fetch(url);
            const data = await response.json();

            if (data.status === 'OK') {
                const address = data.results[0]?.formatted_address;
                return address;
            } else {
                console.error('Geocoding error:', data.status);
                return null;
            }
        } catch (error) {
            console.error('Error fetching location:', error);
            return null;
        }
    };

    useEffect(() => {
        getLocationName(profileData?.baseProfile?.latitude, profileData?.baseProfile?.longitude)
            .then((address) => {
                setProfileLocation(address);
            });

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    getLocationName(latitude, longitude)
                        .then((address) => {
                            setCurrentLocation(address);
                        });
                },
                (error) => {
                    console.error('Error fetching location:', error);
                }
            );
        }
    }, []);

    useEffect(() => {
        const savedTab = localStorage.getItem("activeTab");
        if (savedTab) {
            setActiveTab(savedTab);
        }
    }, []);

    return (
        <Layout>
            <div className="games-wrapper">
                <div className={`d-flex justify-content-center ${isFixed ? "fixed-bar" : ""}`}>
                    <div className={`d-flex justify-content-between w-100 mb-sm-3  ${isFixed ? "fixed-bar-container " : "mt-sm-3"}`} style={{ columnGap: '13px' }} >
                        <Nav
                            activeKey={activeTab}
                            onSelect={(selectedKey) => { setActiveTab(selectedKey); localStorage.setItem("activeTab", selectedKey); }}
                            className="d-flex w-100 custom-tab-nav"
                            style={{ borderRadius: "8px" }}
                        >
                            <Nav.Item className="flex-fill text-center">
                                <Nav.Link eventKey="joined-games" className="games-tab-text">Joined Games</Nav.Link>
                            </Nav.Item>
                            <Nav.Item className="flex-fill text-center">
                                <Nav.Link eventKey="hosted-games" className="games-tab-text" >Hosted Games</Nav.Link>
                            </Nav.Item>
                        </Nav>

                    </div>
                </div>
                <div className="mt-3">
                    {activeTab === 'joined-games' && <MyGame />}
                    {activeTab === 'hosted-games' && <CreatedGames />}
                </div>
            </div>
        </Layout>
    );
};

export default Games;
